import { useMutation, useQueryClient } from 'react-query';

import {
  PendingInviteBulkAddResponseDto,
  PendingInviteBulkResultStatus,
} from '../../../../backend/src/auth/pending-matter-invite/dto/pending-invite-bulk-add.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useAddPendingInvites = ({ matterId }: { matterId: string }) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<PendingInviteBulkAddResponseDto, Error, string[]>(
    async (userEmails) => {
      try {
        const response = await fetch(
          `${APIBaseChronos}/api/matters/${matterId}/pending-invites/bulk`,
          getFetchConfig({ method: FetchMethod.POST, data: { userEmails } }),
        );
        if (!response.ok) throw new Error('Invitation request failed');
        return await response.json();
      } catch {
        return {
          results: userEmails.map((userEmail) => ({
            userEmail,
            status: PendingInviteBulkResultStatus.Failed,
            message: 'Invitation could not be sent',
          })),
        };
      }
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries({ queryKey: [QueryEntity.PendingInvites, { matterId }] });
        queryClient.invalidateQueries({ queryKey: [QueryEntity.Matter, { matterId }] });
      },
    },
  );
};
